/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { CYBERSOURCE_ROUTES } from './routes';

async function post<T>(url: string, body: unknown, signal?: AbortSignal): Promise<T> {
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal,
    });
    if (!response.ok) throw new Error('Apple Pay is unavailable for this cart');
    return response.json() as Promise<T>;
}

export async function prepareNativeCartApplePay(signal?: AbortSignal): Promise<string> {
    const result = await post<{ handoffToken?: unknown }>(CYBERSOURCE_ROUTES.applePayCartHandoff, {}, signal);
    if (typeof result.handoffToken !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(result.handoffToken)) {
        throw new Error('Apple Pay is unavailable for this cart');
    }
    return result.handoffToken;
}

export async function completeNativeCartApplePay(handoffToken: string, orderNo: string): Promise<void> {
    await post(CYBERSOURCE_ROUTES.applePayCartComplete, { handoffToken, orderNo });
}
